import type { SelectionService } from "state/SelectionService";
import { returnToSearchPage, updateSearchFilter } from "state/page";

export interface CollectionTileHandler {
  onClickCollectionTile(this: HTMLElement, event: MouseEvent): void;
  onDblClickCollectionTile(this: HTMLElement, event: MouseEvent): void;
}

export function createCollectionTileHandler(options: {
  selectionService: SelectionService;
}): CollectionTileHandler {
  return {
    onClickCollectionTile(this: HTMLElement, event: MouseEvent) {
      if (event.target instanceof Element && event.target.closest("a")) return;

      const itemId = this.id;
      if (!itemId) return;

      options.selectionService.send({
        type: "ITEM_CLICKED",
        itemId,
        event,
      });
    },
    onDblClickCollectionTile(this: HTMLElement, event: MouseEvent) {
      event.preventDefault();
      event.stopPropagation();

      const folderId = this.id;
      if (!folderId) return;

      returnToSearchPage();
      updateSearchFilter("folderId", folderId);
    },
  };
}
